import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "alert alert-success my-4",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_guiide_transition_shallow = _resolveComponent("guiide-transition-shallow")!

  return (_openBlock(), _createBlock(_component_guiide_transition_shallow, {
    sectionVisible: $data.showMessage,
    slideIn: $data.showMessage
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-exclamation-circle-fill me-2" }, null, -1)),
        _withDirectives(_createElementVNode("span", null, _toDisplayString($props.messagePrefix), 513), [
          [_vShow, $options.showPrefix]
        ]),
        _createTextVNode(" " + _toDisplayString($data.message), 1)
      ], 512), [
        [_vShow, $data.showMessage]
      ])
    ]),
    _: 1
  }, 8, ["sectionVisible", "slideIn"]))
}